import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import {
  Employee,
  MessageHistoryType,
  MessageThread,
  PersonaExpanded,
} from "winslow-core";

import { AgentResponseMessage } from "../../../components/agent-chat/types";
export type AgentState = {
  messages: AgentResponseMessage[];
  employees: Employee[];
  personas: PersonaExpanded[];
  currentThread: MessageThread | null;
  threads: MessageThread[];
  prompt: string;
};

//state to be used by other link preview components
const initialState = {
  messages: [],
  employees: [],
  personas: [],
  currentThread: null,
  threads: [],
  prompt: "",
} as AgentState;

export const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    setPrompt: (state: AgentState, action: PayloadAction<string>) => {
      state.prompt = action.payload;
    },
    setMessages: (
      state: AgentState,
      action: PayloadAction<AgentResponseMessage[]>
    ) => {
      console.log("setMessages", action.payload);
      state.messages = action.payload;
      if (action.payload.length > 0) {
        const threads = action.payload.map((message) => message.messageThread);
        const uniqueThreads = threads.filter(
          (thread, index, self) =>
            index === self.findIndex((t) => t?.id === thread?.id)
        );
        state.threads = uniqueThreads as MessageThread[];
        state.currentThread = uniqueThreads[
          uniqueThreads.length - 1
        ] as MessageThread; //newest thread
      }
    },
    addMessage: (
      state: AgentState,
      action: PayloadAction<AgentResponseMessage>
    ) => {
      state.messages = [...state.messages, action.payload];
      if (action.payload.type === MessageHistoryType.NEW_THREAD) {
        state.currentThread = action.payload.messageThread;
        state.threads = [...state.threads, action.payload.messageThread];
      }
    },

    setEmployees: (state: AgentState, action: PayloadAction<Employee[]>) => {
      state.employees = action.payload;
    },
    setPersonas: (
      state: AgentState,
      action: PayloadAction<PersonaExpanded[]>
    ) => {
      state.personas = action.payload;
    },
    setCurrentThread: (
      state: AgentState,
      action: PayloadAction<MessageThread>
    ) => {
      state.currentThread = action.payload;
    },
    setThreads: (state: AgentState, action: PayloadAction<MessageThread[]>) => {
      state.threads = action.payload;
    },
  },
});

export const {
  setMessages,
  setEmployees,
  setPersonas,
  addMessage,
  setCurrentThread,
  setPrompt,
} = agentSlice.actions;

export const selectMessages = (state: RootState) => state.agent.messages;
export const selectEmployees = (state: RootState) => state.agent.employees;
export const selectPersonas = (state: RootState) => state.agent.personas;
export const selectCurrentThread = (state: RootState) =>
  state.agent.currentThread;
export const selectThreads = (state: RootState) => state.agent.threads;
export const selectPrompt = (state: RootState) => state.agent.prompt;
export default agentSlice.reducer;
